import React from 'react';
import { DogoLogo } from './DogoLogo';
export function Footer() {
  return <footer className="bg-[#050505] border-t border-brand-border p-8 text-center" data-id="element-120">
      <div className="flex items-center justify-center gap-2.5 mb-4" data-id="element-121">
        <DogoLogo size={28} data-id="element-122" />
        <span className="text-[1.1rem] font-extrabold tracking-[4px] text-brand-text uppercase" data-id="element-123">
          DOGOSELL
        </span>
      </div>
      <p className="text-[0.8rem] text-[#444] tracking-[1px] flex flex-wrap items-center justify-center gap-2" data-id="element-124">
        <span data-id="element-125">&copy; 2024 Dogosell. All Rights Reserved.</span>
        <span className="hidden sm:inline" data-id="element-126">|</span>
        <a href="mailto:INFO@DOGOSELL.COM" className="text-brand-red hover:underline decoration-brand-red underline-offset-4" data-id="element-127">
          INFO@DOGOSELL.COM
        </a>
        <span className="hidden sm:inline" data-id="element-128">|</span>
        <a href="tel:+15512331570" className="text-brand-red hover:underline decoration-brand-red underline-offset-4" data-id="element-129">
          +1 551-233-1570
        </a>
      </p>
    </footer>;
}